define([
    'backbone',
    'modules/common/views/tabselecttab',
    'modules/common/controls/control'
], (Backbone, TabView, Control) => Control.extend({

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.get());
                };
                view.on('change', this.callback);
            },
            unbind (view) {
                view.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        },
        enabled (view, value) {
            view.setEnabled(Boolean(value));
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        }
    },

    className: 'tab-select',

    defaults: _.extend({
        id: 'id',
        name: 'name',
        noMargin: false,
        inline: false,
        width: null,
        height: null,
        tabView: TabView
    }, Control.prototype.defaults),

    initialize () {
        Control.prototype.initialize.apply(this, arguments);
        const View = this.options.tabView;

        this.choices = this.options.choices;
        if (!(this.choices instanceof Backbone.Collection)) {
            this.choices = new Backbone.Collection(this.choices);
        }

        this.views = this.choices.map(function (model) {
            model.set('selected', false);
            return new View(_.extend({model, parent: this}, this.options));
        }, this);
    },

    render () {
        this.$el.empty().append(_.map(this.views, (view) => view.render().$el));

        return this;
    },

    get () {
        return _.chain(this.views).filter((view) => view.model.get('selected')).
            map((view) => view.model.id).
            value();
    },

    set (ids) {
        _.each(this.views, (view) => {
            view.model.set('selected', _.contains(ids, view.model.id));
        });
    },

    remove () {
        _.invoke(this.childViews, 'remove');
        return Control.prototype.remove.apply(this, arguments);
    }
}));
